import { render, staticRenderFns } from "./ServicoListFiltroModalItem.vue?vue&type=template&id=58553dc8"
import script from "./ServicoListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports